import axios from 'axios';
import authService from './authService';
import { API_URL } from '@/config/api';

const api = axios.create({
  baseURL: API_URL,
  timeout: 60000,
});

// Interceptor para adicionar token em todas as requisições
api.interceptors.request.use(
  (config) => {
    const token = authService.token.get();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratamento de erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      authService.logout();
    }
    return Promise.reject(error);
  }
);

const flashcardService = {
  // ========== TEMAS DE FLASHCARD ==========

  // Criar novo tema
  async criarTema(nome) {
    try {
      const response = await api.post('/flashcards/tema', null, {
        params: { nome }
      });
      return response;
    } catch (error) {
      console.error('Erro ao criar tema de flashcard:', error);
      throw error;
    }
  },

  // Listar todos os temas
  async listarTemas() {
    try {
      const response = await api.get('/flashcards/tema');
      return response;
    } catch (error) {
      console.error('Erro ao listar temas de flashcard:', error);
      throw error;
    }
  },

  // Editar nome do tema
  async editarTema(temaId, nome) {
    try {
      const response = await api.put(`/flashcards/tema/${temaId}`, {
        nome
      });
      return response;
    } catch (error) {
      console.error('Erro ao editar tema de flashcard:', error);
      throw error;
    }
  },

  // ========== FLASHCARDS ==========

  // Criar flashcard individual
  async criarFlashcard(flashcard) {
    try {
      const response = await api.post('/flashcards', flashcard);
      return response;
    } catch (error) {
      console.error('Erro ao criar flashcard:', error);
      throw error;
    }
  },

  // Importar flashcards via CSV
  async importarCSV(temaId, file) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post('/flashcards/importar', formData, {
        params: { temaId },
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response;
    } catch (error) {
      console.error('Erro ao importar flashcards:', error);
      throw error;
    }
  },

  // ========== ESTUDO/REVISÃO ==========

  // Buscar flashcards para revisão
  async buscarFlashcardsRevisao(temaId = null) {
    try {
      const params = temaId ? { temaId } : {};
      const response = await api.get('/flashcards/revisao', { params });
      return response;
    } catch (error) {
      console.error('Erro ao buscar flashcards para revisão:', error);
      throw error;
    }
  },

  // Avaliar flashcard
  async avaliarFlashcard(flashcardId, nivel) {
    try {
      const response = await api.post(`/flashcards/${flashcardId}/avaliar`, {
        nivel
      });
      return response;
    } catch (error) {
      console.error('Erro ao avaliar flashcard:', error);
      throw error;
    }
  },

  // Buscar informações de revisão de um flashcard específico
  async buscarRevisaoInfo(flashcardId) {
    try {
      const response = await api.get(`/flashcards/${flashcardId}/revisao-info`);
      return response;
    } catch (error) {
      console.error('Erro ao buscar informações de revisão:', error);
      throw error;
    }
  },

  // Explicar flashcard com IA
  async explicarFlashcard(flashcardId) {
    try {
      const response = await api.post(`/flashcards/${flashcardId}/explicar`);
      return response;
    } catch (error) {
      console.error('Erro ao gerar explicação com IA:', error);
      throw error;
    }
  }
};

export default flashcardService;
